module.exports = function (sprintf) {
  'use strict';

  return function (singular, plural, count) {
    if (count > 1) return sprintf(plural, { count: count });

    return sprintf(singular, { count: count });
  };
};
